import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  id: "payment-credit-card"
};
const _hoisted_2 = {
  class: "cart-page-body"
};
const _hoisted_3 = {
  class: "cart-page-left"
};
const _hoisted_4 = {
  class: "cart-page-left-alerts"
};
const _hoisted_5 = {
  class: "payment-credit-card-details"
};
const _hoisted_6 = {
  class: "payment-header"
};
const _hoisted_7 = {
  class: "payment-body"
};
const _hoisted_8 = {
  class: "payment-card-details card-number"
};
const _hoisted_9 = {
  class: "payment-details-card-number-title"
};
const _hoisted_10 = {
  class: "card-number-details"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  key: 1,
  id: "ameximg",
  class: "ccImgs",
  alt: "American Express logo",
  src: "/content/dam/images/public-images/logos/a-c/american-express/American-Express-Square-Logo.png",
  height: "36px",
  width: "36px"
};
const _hoisted_13 = {
  key: 2,
  id: "visaimg",
  class: "ccImgs",
  alt: "Visa logo",
  src: "/content/dam/images/public-images/logos/v-x/visa/visa-brandmark-blue-1960x622.png",
  height: "40px",
  width: "40px"
};
const _hoisted_14 = {
  key: 3,
  id: "mcimg",
  class: "ccImgs",
  alt: "Mastercard logo",
  src: "/content/dam/images/public-images/logos/m-o/mastercard/mc_symbol.svg",
  height: "20px",
  width: "20px"
};
const _hoisted_15 = {
  key: 4,
  class: "discdiv"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  id: "discimg",
  alt: "Discover logo",
  src: "/content/dam/images/public-images/logos/d-f/discover/discover.png",
  height: "80px",
  width: "80px"
}, null, -1);
const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  key: 0,
  class: "error-message card-number"
};
const _hoisted_19 = {
  key: 1,
  class: "error-message card-number"
};
const _hoisted_20 = {
  key: 2,
  class: "error-message expiry-date"
};
const _hoisted_21 = {
  class: "payment-card-details"
};
const _hoisted_22 = {
  class: "payment-details-expiration-title"
};
const _hoisted_23 = {
  class: "payment-details-expiration-date"
};
const _hoisted_24 = {
  key: 0,
  class: "error-message expire"
};
const _hoisted_25 = {
  class: "cart-page-right"
};
const _hoisted_26 = {
  class: "order-summary-payment"
};
const _hoisted_27 = {
  class: "order-summary-title"
};
const _hoisted_28 = {
  class: "order-summary-multiple-po"
};
const _hoisted_29 = {
  class: "order-summary-multiple-po-title"
};
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = {
  class: "order-summary-multiple-po-number notranslate"
};
const _hoisted_32 = {
  class: "order-summary-multiple-po-item-line-price"
};
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_34 = {
  class: "order-summary-multiple-po-number notranslate"
};
const _hoisted_35 = {
  class: "order-summary-multiple-po-item-line-price"
};
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_37 = {
  class: "order-summary-checkout-info"
};
const _hoisted_38 = {
  class: "order-summary-buttons payment-btn"
};
const _hoisted_39 = ["aria-label", "value"];
const _hoisted_40 = ["aria-label"];
const _hoisted_41 = ["aria-label"];
const _hoisted_42 = ["arial-label"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingDots = _resolveComponent("LoadingDots");
  const _component_StatusBar = _resolveComponent("StatusBar");
  const _component_PurchaseCartAlert = _resolveComponent("PurchaseCartAlert");
  const _component_DcSelectBox = _resolveComponent("DcSelectBox");
  const _component_ChevronIcon = _resolveComponent("ChevronIcon");
  const _component_DcModal = _resolveComponent("DcModal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_LoadingDots, {
    loading: $data.loading || $data.saveLoading || $data.hideDetails
  }, null, 8, ["loading"]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_StatusBar, {
    steps: $data.paymentSteps
  }, null, 8, ["steps"])], 512), [[_vShow, !$data.loading]]), _withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$data.apiCallFailure ? (_openBlock(), _createBlock(_component_PurchaseCartAlert, {
    key: 0,
    message: $options.getLabel('deliveryDetails.page.trackDelivery.error'),
    icon: 'exclamation-point-icon',
    color: 'error'
  }, null, 8, ["message"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($options.getLabel('credit.cardDetails')), 1), _withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString($options.getLabel('credit.cardNumber')), 1), _createElementVNode("div", _hoisted_10, [$data.paymentData?.paymentHostUrl && $data.paymentData.paymentHostUrl !== '' ? (_openBlock(), _createElementBlock("iframe", {
    id: "payment-card-iframe",
    src: $data.paymentData.paymentHostUrl,
    key: $data.iframeKey,
    onLoad: _cache[0] || (_cache[0] = $event => $options.setupListeners()),
    width: "312",
    height: "44",
    frameborder: "0",
    scrolling: "no"
  }, "\n                                ", 40, _hoisted_11)) : _createCommentVNode("", true), $data.cardType == 'AMEX' ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : $data.cardType == 'VISA' ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : $data.cardType == 'MC' ? (_openBlock(), _createElementBlock("img", _hoisted_14)) : $data.cardType == 'DISC' ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)) : _createCommentVNode("", true)]), $data.cardNumberError && $data.cardType != 'AMEX' ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString($options.getLabel('order.checkout.creditcard.errormessage')), 1)) : $data.cardNumberError ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString($options.getLabel('amex.credit.cardError')), 1)) : _createCommentVNode("", true), $data.expiryDateError ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString($options.getLabel('paymentOption.deliveryDate.expiryDate')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString($options.getLabel('expiration.date')), 1), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
    class: _normalizeClass(["payment-month", {
      'error': $data.expirationDateError
    }])
  }, [_createVNode(_component_DcSelectBox, {
    name: "month",
    label: $options.getLabel('paymentTerms.month'),
    options: $options.months,
    "current-selection": $data.cardExpireMonthIndex,
    onSelectDropdown: _cache[1] || (_cache[1] = $event => $options.handleMonthSelection($event))
  }, null, 8, ["label", "options", "current-selection"])], 2), _createElementVNode("div", {
    class: _normalizeClass(["payment-year", {
      'error': $data.expirationDateError
    }])
  }, [_createVNode(_component_DcSelectBox, {
    name: "year",
    label: $options.getLabel('paymentTerms.year'),
    options: $options.years,
    "current-selection": $data.cardExpireYearIndex,
    onSelectDropdown: _cache[2] || (_cache[2] = $event => $options.handleYearSelection($event))
  }, null, 8, ["label", "options", "current-selection"])], 2)]), $data.expirationDateError ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString($options.getLabel('checkout.paymentOption.expiration.date.error')), 1)) : _createCommentVNode("", true)])], 512), [[_vShow, !$data.hideDetails]])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("h4", _hoisted_27, _toDisplayString($options.getLabel('order.summary.Title')), 1), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
    class: _normalizeClass(["order-summary-multiple-po-title-wrapper", {
      'expanded': $data.isExpanded
    }])
  }, [_createElementVNode("p", _hoisted_29, _toDisplayString($options.getLabel('text.search.option.poNo')), 1), _createVNode(_component_ChevronIcon, {
    tabindex: "0",
    onClick: $options.toggleIsExpanded,
    onKeydown: [_withKeys(_withModifiers($options.toggleIsExpanded, ["prevent"]), ["enter"]), _withKeys(_withModifiers($options.toggleIsExpanded, ["prevent"]), ["space"])]
  }, null, 8, ["onClick", "onKeydown"])], 2), $options.isMultiPO() ? (_openBlock(), _createElementBlock("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.totalsByPo(), (poEntry, index) => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      key: index,
      class: "order-summary-multiple-po-item"
    }, [_createElementVNode("span", _hoisted_31, _toDisplayString(poEntry.poNumber), 1), _createElementVNode("span", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(poEntry.totalsByPoList, (currencyEntry, idx) => {
      return _openBlock(), _createElementBlock("span", {
        key: idx
      }, [_createTextVNode(_toDisplayString(currencyEntry.totalsByCurrency.subtotalAmountFormatted) + " " + _toDisplayString(currencyEntry.currency), 1), _hoisted_33]);
    }), 128))])])), [[_vShow, $data.isExpanded]]);
  }), 128))])) : _withDirectives((_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['order-summary-subtotal', {
      'multiple-subtotals': $options.hasMultipleSubtotals()
    }])
  }, [_createElementVNode("span", _hoisted_34, _toDisplayString($options.singlePo()), 1), _createElementVNode("span", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.subTotals(), (subtotal, index) => {
    return _openBlock(), _createElementBlock("span", {
      key: index
    }, [_createTextVNode(_toDisplayString(subtotal) + " " + _toDisplayString($options.getCurrencies()[index]) + " ", 1), _hoisted_36]);
  }), 128))])], 2)), [[_vShow, $data.isExpanded]])]), _createElementVNode("div", _hoisted_37, _toDisplayString($options.isIndia() ? $options.getLabel('cart.order.summary.message.checkout.india') : $options.getLabel('checkout.des.text')), 1), _createElementVNode("div", _hoisted_38, [_createElementVNode("input", {
    class: "order-summary-buttons-checkout review-place",
    "aria-label": $options.getLabel('checkout.checkoutBtn'),
    type: "button",
    value: $options.getLabel('checkout.checkoutBtn'),
    onClick: _cache[3] || (_cache[3] = $event => $options.completePayment()),
    onKeydown: _cache[4] || (_cache[4] = _withKeys($event => $options.completePayment(), ["enter"]))
  }, null, 40, _hoisted_39)])])])], 512), [[_vShow, !$data.loading]])]), $data.showSimulateErrorModal ? (_openBlock(), _createBlock(_component_DcModal, {
    key: 0,
    onModalClose: _cache[7] || (_cache[7] = $event => $options.clearCreditCardDetails())
  }, {
    header: _withCtx(() => [_createElementVNode("h4", {
      "aria-label": $options.getLabel('error')
    }, _toDisplayString($options.getLabel('error')), 9, _hoisted_40)]),
    body: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.simulateErrorMessages, (simulateErrorMessage, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "simulate-error",
        key: index
      }, [_createElementVNode("p", null, _toDisplayString(simulateErrorMessage), 1)]);
    }), 128))]),
    footer: _withCtx(() => [_createElementVNode("button", {
      class: "simulate-modal-go-to-cart",
      onClick: _cache[5] || (_cache[5] = $event => $options.redirectToCart()),
      "aria-label": $options.getLabel('cart.page.gotocart.label')
    }, _toDisplayString($options.getLabel('cart.page.gotocart.label')), 9, _hoisted_41), _createElementVNode("button", {
      class: "simulate-modal-close",
      type: "submit",
      onClick: _cache[6] || (_cache[6] = $event => $options.clearCreditCardDetails()),
      "arial-label": $options.getLabel('button.close.UPPER')
    }, _toDisplayString($options.getLabel('button.close.UPPER')), 9, _hoisted_42)]),
    _: 1
  })) : _createCommentVNode("", true)], 64);
}